// LIBRARIES
import styled from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 70px 80px;
`;
export const Title = styled.text`
  font-size: 30px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.cornflowerBlue};
  margin-bottom: 20px;
`;
export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 60px;
`;
export const CardDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 750px;
  height: 553px;
  padding: 20px 20px 50px 20px;
  background: ${COLORS.primaryWhite};
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  border-radius: 10px;
`;
export const InputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const InputContainer = styled.div`
  max-width: 260px;
`;
export const DatesInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 310px;
  justify-content: space-between;
`;
export const DateInputContainer = styled.div`
  max-width: 145px;
`;
export const DescriptionContainer = styled.div``;
export const SearchingContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const SearchingBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: 750px;
  height: 109px;
  padding: 20px;
  background: ${COLORS.primaryWhite};
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  z-index: 1;
  border-radius: 10px;
`;
export const LeftContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
export const ProfilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;
  height: 454px;
  background: ${COLORS.primaryWhite};
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  margin-top: -10px;
  border-radius: 10px;
`;
export const ButtonContainer = styled.div`
  max-width: 169px;
  margin: 0 auto;
`;
export const SearchButtonContainer = styled.div``;
export const IconContainer = styled.img`
  margin-left: 30px;
  width: 46px;
  height: 46px;
`;
export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 0 0 80px;
  @media (${WIDTH.mediumWidth}) {
    margin-left: 40px;
  }
`;
export const UsersWrapper = styled.div`
  width: 750px;
  height: 454px;
  border-radius: 10px;
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  background-color: ${COLORS.primaryWhite};
  padding: 10px 20px 50px 20px;
  margin-top: -8px;
  @media (${WIDTH.mediumWidth}) {
    width: 620px;
  }
`;

export const UsersContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 3px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${COLORS.backgroundColor};
    border-radius: 10px;
    margin-block: 9px;
    margin-left: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(
      180deg,
      ${COLORS.cornflowerBlue} 0%,
      ${COLORS.rainbowIndigo} 100%
    );
    border-radius: 10px;
  }
`;
